import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../../web/components-v2/Theme/theme';

/**
 * Styles for `SurveySections` — respondent + preview.
 *
 * Matches the section design (Sketch "Dynamic Surveys"): a section is purely
 * typographic — no card or border. The title is a small UPPERCASE bold
 * "eyebrow" sitting directly above its questions, with an optional muted
 * description paragraph beneath it. Mirrors the editor's section-title
 * convention (sm / 600 / letter-spaced / uppercase) so the respondent view
 * reads consistently with how authors labelled the section.
 */
export const styleSheet = StyleSheet.create({
	/**
	 * One section block. A flex column with a gap so the header and each question
	 * are evenly spaced — this restores the inter-question spacing the parent form
	 * provides between flat questions (questions nested inside a section are no
	 * longer direct children of the form's flex `gap`). `marginBottom` adds the
	 * extra separation between consecutive sections.
	 */
	section: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.lg,
		marginBottom: THEME.spacing.lg,
	},
	/**
	 * Section title + optional description. Explicitly left-aligned: the survey
	 * response page centers content by default (the same reason the question
	 * `label` style sets `textAlign: 'left'`).
	 */
	sectionHeader: {
		textAlign: 'left',
	},
	/** Section title — small uppercase bold eyebrow above the section's questions. */
	sectionTitle: {
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
		letterSpacing: 0.5,
		textTransform: 'uppercase',
		color: THEME.colors.text.main,
		textAlign: 'left',
		margin: 0,
	},
	/** Optional descriptive text below the title — muted, regular weight. */
	sectionDescription: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
		textAlign: 'left',
		margin: 0,
		marginTop: THEME.spacing.xs,
	},
});
